import { useEffect, useState } from 'react';
import { Download, X } from 'lucide-react';

const DISMISS_KEY = 'mtk_pwa_install_dismissed_v1';

export default function PWAInstallBanner() {
  const [prompt, setPrompt] = useState(null);
  const [visible, setVisible] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // Detect iOS (no beforeinstallprompt support)
    const ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const standalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
    const dismissed = localStorage.getItem(DISMISS_KEY);

    if (standalone || dismissed) return;

    if (ios) {
      setIsIOS(true);
      setTimeout(() => setVisible(true), 3000);
      return;
    }

    const handler = (e) => {
      e.preventDefault();
      setPrompt(e);
      setTimeout(() => setVisible(true), 3000);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const install = async () => {
    if (!prompt) return;
    prompt.prompt();
    const choice = await prompt.userChoice;
    if (choice.outcome === 'accepted') setVisible(false);
  };

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-[88px] left-4 right-4 z-[60] sm:left-auto sm:right-4 sm:max-w-sm animate-fade-up" data-testid="pwa-install-banner">
      <div className="rounded-2xl bg-[#0F0F10] text-white p-4 shadow-2xl flex items-start gap-3 border border-white/10">
        <div className="w-10 h-10 rounded-xl brand-gradient flex-shrink-0 flex items-center justify-center">
          <Download size={18} className="text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-bold">Install Meet to Keep</p>
          {isIOS ? (
            <p className="text-xs text-white/70 mt-0.5 leading-relaxed">
              Tap <span className="inline-block px-1">⎙</span> Share, then <span className="font-semibold">"Add to Home Screen"</span>
            </p>
          ) : (
            <p className="text-xs text-white/70 mt-0.5">Get the full app experience. One tap from your home screen.</p>
          )}
          {!isIOS && prompt && (
            <button onClick={install} data-testid="pwa-install-btn"
              className="mt-2.5 brand-gradient text-white text-xs font-semibold px-4 py-2 rounded-full hover:scale-[1.02] transition-all">
              Install
            </button>
          )}
        </div>
        <button onClick={dismiss} data-testid="pwa-dismiss-btn" className="text-white/60 hover:text-white p-1">
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
